

























































































  import { Component, Vue,Prop, Watch } from 'vue-property-decorator';
  import { store, StoreState,HellospokeContact ,AppSettings,HellospokeUser } from '../store';
	import { mapState } from 'vuex';
	import VueElementLoading from "vue-element-loading";
	import { RotateSquare2 } from "vue-loading-spinner";  
	import AES from 'crypto-js/aes';  
  import CryptoJS from 'crypto-js';  
  import Sidebar from "../components/Sidebar.vue"; 
  import axios from 'axios'; 
  import fs from 'fs';

	 


	//From section 3.2.3
	declare interface CallForward {
		enabled: boolean;
		number: string;
		substitute: boolean;
		keep_caller_id: boolean;
	} 

	declare interface Settings {
		// call_forward: CallForward;
    enable_call_forward: boolean;
		vm_to_email_enabled: boolean;
    phone_number: string;
		email: string;
    ring_voip_phone: boolean;
    keep_caller_id: boolean;
	}

	@Component({
		components: {
      RotateSquare2,VueElementLoading,  Sidebar, 
		},
        computed: {
            ...mapState({
            'settings': (state: StoreState) => state.account.settings,
            'devices': (state: StoreState) => state.account.devices,
            userfirstname: (state: StoreState) => state.dashboard.userfirstname, 
            userlastname: (state: StoreState) => state.dashboard.userlastname,
            'Account_id': (state: StoreState) => state.account.account_id ,
            'Userdashbord': (state: StoreState) => state.dashboard.User_dashbord,
            'user_image_url': (state: StoreState) => state.dashboard.user_image_url,
       })
        },

      methods:{
       fileChange(file) {
            // To check if file is an image
            if (!file.target.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
                alert('not an image');
                file.target.value = null
                this.$emit('imageChanged', null)
                return;
            }
             this.$data.cropped_status=true;
            var reader = new FileReader();
            reader.readAsDataURL(file.target.files[0]);
            reader.onload = () => {
                this.$data.dialog = true;
                // bind the result of the file 
                // to croppie
                  var self= (this.$refs as any);
                   self.croppieRef.bind({
                            url: reader.result,
                    });
               
                file.target.value = null
            };
            reader.onerror = (error) => {
                console.log('Error: ', error);
            };
        },
       
       
        
       
     }
    })


	export default class MySettings extends Vue {
		data() {
			return {
            show: true,
            cropped: null,
            cropped_status:false,
            imgDataUrl: '' ,// the datebase64 url of created image
                settings_data : {
                    enable_call_forward: false,
                    vm_to_email_enabled: false,
                    phone_number: "",
                    email: "",
                    ring_voip_phone: false,
                    keep_caller_id: false,
                    imageUrl:''
                },
                feedback_text: "",
                feedback_success: false,
                mysetting_enable:false,
                URLIMGPLUS_G:"/img/icons/camera.png",//"/img/rose-blue.jpeg",
                model_status:'',
                userIdRev: {},
                user_profile:'',
                imageupload:false,
                imagUploading:false,

               // croppieRef:'',
                default: String,
                cropper: Boolean,
                cropperWidth: {
                    type: Number,
                    default: 257
                },
                src: String,
			} //as MySettingsData
    }
    
    @Prop()
    public users!: HellospokeUser[];
    
   
    created() {
      this.$data.mysetting_enable=true;
			this.$store.dispatch("getSettings").then(r => {
         this.$data.model_status=JSON.stringify(r);
      //  alert(JSON.stringify(r))
      this.$data.userIdRev = {
          id: r.data.data.id,
          rev: r.data.revision
        };
        this.$data.mysetting_enable=false;
        // alert((this as any).list);
			})
			.catch(e => {
				this.$data.mysetting_enable=false;
			//	console.log(e);
				});
    }
  
    @Watch('settings', { deep: true })
    onSettingsChange() {
        this.setSettings();
    }

    @Watch('settings_data', { deep: true })
    onSettingsDataChange() {
        if(this.$data.feedback_text !== "") {
            this.$data.feedback_text = '';
            this.$data.feedback_success = false;
        }
		}

		openChooseFile() {
			document.getElementById('avatarFile').click();
		}
     isNumber(event, message) {
            if (!/\d/.test(event.key) &&  
                (event.key !== "." || /\./.test(message))     
            )  
                return event.preventDefault();  
            }
		handleFileChange(e, index) {
      const avatarFile = e.target.files[0];
      let fd = new FormData();
      fd.append('file', avatarFile);
      fd.append('id', this.$data.userIdRev.id);
      fd.append('rev', this.$data.userIdRev.rev);
			this.$store.dispatch("uploadAvatar", fd).then(r => {
				console.log(r);
			})
			.catch(e => {
				console.log(e);
			})
		}
		

  setSettings() {
            ['enable_call_forward', 'vm_to_email_enabled', 'phone_number', 'email', 'ring_voip_phone', 'keep_caller_id','imageUrl'].forEach(key => {
                this.$data.settings_data[key] = (this as any).settings[key];
            });
    }
   
    //  fileUploaded(files) {    
    //         var FileSize=files[0].size;
    //         var Max_fileSize=Math.round(FileSize / 1000000); //size in mb;
    //         if(Max_fileSize>4)
    //             {
    //                alert('Attachment may not exceed 5MB.');
    //             }
    //        else{
    //             this.$data.sendingImage = true;
    //              (this as any).imagUploading=true;
    //             let formData = new FormData();
    //             //JSON.parse(JSON.stringify((this as any).selectedContact))
    //             formData.append('file', files[0]);
    //             debugger;
    //             axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.account.jwt;
    //             axios.post( `${AppSettings.API_HOST}uploadContactImage`,
    //                 formData,
    //                 {
    //                     headers: {
    //                         'Content-Type': 'multipart/form-data'
    //                     },
    //                 }
    //             ).then(r => {
    //               //alert(r.data.imageurl)
    //                  (this as any).URLIMGPLUS_G=(this as any).user_profile=(this as any).settings_data.imageUrl= r.data.imageurl;
    //                  this.$store.commit('SET_USER_IMAGE', r.data.imageurl);
    //                 // this.$refs.croppieRef=r.data.imageurl;
    //                 this.ImageUpadte();
    //                // (this as any).imagUploading=false;
    //                  (this as any).imageupload=true;
    //                   //this.submit()
    //             });
    //        }
    //     }

      cancel_crop(){
           this.$data.cropped_status=false;
        }
      //// CALBACK USAGE
        crop() {
            // Here we are getting the result via callback function
            // and set the result to this.cropped which is being 
            // used to display the result above.
               this.$data.sendingImage = true;
               (this as any).imagUploading=true;
              var self= (this.$refs as any);
              let options = {
                  format: 'jpeg', 
                  circle: true
              };
            self.croppieRef.result(options, (output) => { 
                this.$data.cropped = output;
                this.cancel_crop();
                this.ImageUpadte();
               /// console.log(output)
            });  
        }
      async ImageUpadte() {
       // let base64String = 'data:image/jpeg;base64,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'; // Not a real image
      // Remove header
        const payload = { imageUrl:this.$data.cropped  }
            await this.$store.dispatch("updateImageSettings", payload).then(r => {
                 (this as any).settings_data.imageUrl=this.$data.cropped;
                  this.$store.commit('SET_USER_IMAGE', this.$data.cropped);
                   this.$data.cropped_status=false;
                     (this as any).imagUploading=false;
                     (this as any).imageupload=true;
                    this.$data.mysetting_enable=false;
                }).catch(() => {
                     this.$data.mysetting_enable=false;
                 });
        (this as any).imagUploading=false;
        //To set imager for user
        this.update();  
      }
		
     get loger_Name()
       {
          this.$data.notifications_open = true;
          var Login_User=AES.decrypt(decodeURI((this as any).$cookies.get('username')),"2r5u8x/A").toString(CryptoJS.enc.Utf8);
          Login_User=Login_User.substring(0,Login_User.indexOf('@'));
          return Login_User;
        }
    

		async submit() {
      //this.$data.feedback_success = false;
      this.$data.mysetting_enable=true;
       if(this.$data.settings_data.enable_call_forward && this.isPhoneNumberValid(this.$data.settings_data.phone_number) === false
       && this.$data.settings_data.vm_to_email_enabled && this.validateEmail(this.$data.settings_data.email) === false)
       {
        this.$data.mysetting_enable=false;
        this.$data.feedback_text = "Please enter a valid phone number & email address." ;
        return;
      }
      if(this.$data.settings_data.enable_call_forward && this.isPhoneNumberValid(this.$data.settings_data.phone_number) === false)
       {
       //this.Feedback_mesg('error','Please enter a valid phone number');
        this.$data.feedback_text = "Please enter a valid phone number.";
        this.$data.mysetting_enable=false;
				return;
			}

      if(this.$data.settings_data.vm_to_email_enabled && this.validateEmail(this.$data.settings_data.email) === false) 
      {
       //this.Feedback_mesg('error','Please enter a valid email address');
        this.$data.mysetting_enable=false;
		 	  this.$data.feedback_text = "Please enter a valid email address.";
        return;
      }
            const payload = {
                enable_call_forward: this.$data.settings_data.enable_call_forward, 
                vm_to_email_enabled: this.$data.settings_data.vm_to_email_enabled,
                phone_number: this.$data.settings_data.phone_number,
                email: this.$data.settings_data.email,
                ring_voip_phone: this.$data.settings_data.ring_voip_phone,
                keep_caller_id: this.$data.settings_data.keep_caller_id,
                imageUrl:(this as any).settings_data.imageUrl
            }
            await this.$store.dispatch("updateSettings", payload).then(r => {   
              //alert(JSON.stringify(r)) 
                    this.$data.mysetting_enable=false;
                }).catch(() => {
                     this.$data.mysetting_enable=false;
                 });
                   (this as any).imagUploading=false;
           // this.$store.commit('SET_SETTINGS', r.data);
           // this.Feedback_mesg('success','Settings saved');
           //  this.update();
        	this.$data.feedback_text = "Settings saved";
          this.$data.feedback_success = true;
    }
    
  
		isPhoneNumberValid(phoneNumber: string) {
			if(!phoneNumber) {
				return false;
			}

			if(typeof phoneNumber === "number") {
				phoneNumber = (phoneNumber as any).toString();
			}
			//strip all potential nondigits
      phoneNumber = phoneNumber.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
      if(!(/[1-9]{1}[0-9]{9}/.test(phoneNumber)))
          {
            return false;
           }
			//Allow US country code if supplied
			const re = /^1?\d{10}$/;
			if(!re.test(phoneNumber)) {  
				return false;
			}
			return true;
		}

		validateEmail(email: string) {
			//Breakdown of this Regex can be found here:
			//https://www.w3resource.com/javascript/form/email-validation.php
			//Seems to cover most all cases.
			//I believe this handles + with anything after it. If you find an exception
			//let me know and I'll fix.
			const re = /^\w+([\.-]?\w+)*(\+.*)?@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			return re.test(email);
    }
      


    async update() { 
      this.$data.mysetting_enable=false;
            const payload = {
                account_id: (this as any).Account_id,  
                users: null
            };
           let _users = JSON.parse(JSON.stringify((this as any).Userdashbord));
            let updated_users= [];
           for(const user of _users) {
             if(user._id==this.$data.userIdRev.id){
                user.imageUrl=(this as any).settings_data.imageUrl;
                updated_users.push(user);
                 }
              }
             payload.users =  updated_users;
            const response = await this.updateUsers(payload);
            
          }

        async updateUsers(payload: any) 
	    	{
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.account.jwt;
            const r = await axios.put(`${AppSettings.API_HOST}updateUsers`, {payload: payload});
            return r.data;
        }

		
	}
